<template>
  <AppTableControl
    no-export
    @search-clicked="filteredRole"
    @query-debounced="searchName"
  >
    <template #filters>
      <div class="d-flex">
        <b-form-group label="Type" class="mr-3">
          <b-form-select
            v-model="type"
            :options="roleMemberTypes"
            class="form-control-solid"
          >
          </b-form-select>
        </b-form-group>
      </div>
    </template>
  </AppTableControl>
</template>

<script>
import AppTableControl from "@/modules/core/components/shared/filter/AppTableControl";
import { mapGetters } from "vuex";
export default {
  name: "TeacherAdminPageTableControl",
  components: { AppTableControl },
  data() {
    return {
      roleMemberTypes: [
        { value: 1, text: "All" },
        { value: 2, text: "Super Admin" },
        { value: 3, text: "Admin" },
        { value: 4, text: "Member" },
      ],
      type: 1,
    };
  },
  beforeDestroy() {
    this.$store.dispatch("changeTeacherAdminListNameFilters", {
      name: name,
    });

    this.$store.dispatch("changeTeacherAdminListRoleFilters", {
      role: 1,
    });
  },
  methods: {
    filteredRole() {
      console.log("Role: ", this.type);
      this.$store.dispatch("changeTeacherAdminListRoleFilters", {
        role: this.type,
      });

      this.fetch();
    },

    /**
     * Search
     * @param name
     */
    searchName(name) {
      console.log("Name", name);

      this.$store.dispatch("changeTeacherAdminListNameFilters", {
        name: name,
      });

      this.fetch();
    },

    fetch() {
      this.$store.dispatch("fetchTeacherAdminList");
    },
  },
  computed: {
    ...mapGetters({
      role: "getTeacherAdminListRoleFilters",
    }),
  },
};
</script>

<style scoped></style>
